import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link } from "react-router-dom";
import { FaRegImage, FaLink, FaStepBackward } from "react-icons/fa";
import $ from "jquery";
import WOW from "wowjs";
import { useParams,useNavigate } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { GetEventList } from '../../api/events-functions'
import { GetEventsGalleryList } from "../../api/events-gallery-functions";
import FsLightbox from "fslightbox-react";
import axios from "axios";
import Metatag from "../../hooks/Metatag";
import globalVariables from "../../global-variables";


export default function EventDetail() {
  const [toggler, setToggler] = useState(false);
  const [index, setIndex] = useState(0);

  const navigate = useNavigate();
  
  useEffect(() => {
    // add class for home header and remove inner class
    $(".fixed-top").addClass("bg-header");

  }, []);

  let { event_pagename } = useParams();
  const qs_event_pagename = event_pagename 
  
   // constant to be used on the page
   const [events, setEventsList] = useState(null);
  
   const [events_gallery_toggler, setEventsGalleryToggler] = useState(false);
   const [events_gallery, setEventsGallery] = useState([]);

   const [gallery_key, setGalleryKey] = useState("");

   const [videos, setvideosToggler] = useState(false);

   const [lightbox_video, setLightBoxVideo] = useState([]);

   //Event presentation list 
   const [eventPresentationList, setEventPresentationList] = useState([]);
    
  // success function when the list is retrived
  const OnGetEventsSuccess = (p_response) => {
    // set the list for looping
    setEventsList(p_response);
    }

    // success function when events gallery is retrived
    const OnGetEventsGallerySuccess = (p_response) => {

      // let _arrGallery = [];

      // // loop and make the array for binding the gallery
      // for (let i = 0; i < p_response.length; i++) {
      // _arrGallery.push(global.variables.strApiUrl + "/events-gallery-image/" + p_response[i].egallery_pic);
      // }

      // set the array in the constant
      setEventsGallery(p_response);

      setGalleryKey(Date.now())

      // using time out for the value to get saved in state 
      setTimeout(() => {
      // trigger the link click to display the news gallery popup
      document.getElementById("lnk_trigger_events_gallery_popup").click();
      }, 200);

      }

      // function to invoke photo gallery
      const InvokePhotoGallery = (e, p_event_id) => {
      e.preventDefault();
      // Make an object for getting news gallery
      let _objEventsGallery = new Object();
      _objEventsGallery.egallery_status = 1;
      _objEventsGallery.egallery_event_id = p_event_id;

      // call the function to get the news gallery
      GetEventsGalleryList(_objEventsGallery, OnGetEventsGallerySuccess,navigate);

      };

      // function to invoke video popup
      const InvokeVideoPopup = (e, p_event_video_url) => {

      e.preventDefault();

      let _arrVideos = [];
      _arrVideos.push(p_event_video_url);

      // set the path to the constant for displaying
      setLightBoxVideo(_arrVideos);

      // trigger the link click to display the popup
      document.getElementById("lnk_trigger_video_popup_event").click();

      };


  // things to be done when the page is loaded
    useEffect(() => {

    //make the object for getting the event list
    let _objEvent = new Object();
    _objEvent.event_pagename = qs_event_pagename;
    _objEvent.event_status = 1;
    // call the function to get the event detail
    GetEventList(_objEvent,OnGetEventsSuccess,navigate);

  }, [qs_event_pagename]);
  
  
  // things to be done when the page is loaded
  useEffect(()=>{
    let _obj = new Object();
    if(events != null){

      _obj.evtdoc_event_id = events[0]?.event_id;

      axios.post(global.variables.strApiUrl + '/eventdocumentApi/geteventdocumentList',_obj)
      .then((response)=>{
        if(response.data === 'error')
        {
          navigate('/error-page')
        }
        else
        {
          setEventPresentationList(response.data[0])
        }
      })
    }
},[events])
  
  useEffect(()=>{
      // initiate the wow effect
      new WOW.WOW({
        live: false,
      }).init();
  
  
  },[])
  return (
    <>
      <Header main_className="bg-header"></Header>
      {
        events != null ?
        <Metatag title={events[0].event_pagetitle}  
                  keywords={events[0].event_meta_keywords} 
                  description={events[0].event_meta_description}
                  />
        :
        null
      }

      <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('../images/bg-events.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
        <img src={global.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
        <div className="masthead d-flex align-items-center w-100">
          <Container className="px-4 px-md-5 pb-xl-5 py-4">
            <div className="d-flex align-items-end">
              <div className="d-inline-block m-0 d-flex align-items-center">
                <h1 className="mb-0 fw-bold text-white text-uppercase">EVENTS</h1>
              </div>
            </div>
          </Container>
        </div>
      </Container>

      <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
        {
          events != null ?
            <Container className="px-0 bg-panels">
              <Row className="box p-xl-4 p-2 rounded-3">
                <Col xxl={3} xl="4" lg={6} className="position-relative rounded-2">
                  {
                    events[0].event_thumbnail != "" && events[0].event_thumbnail != null ?
                     parseInt(events[0].event_gallery_count) > 0 ?
                        <figure className="rounded-2 ">
                          <Link onClick={event => InvokePhotoGallery(event, events[0].event_id)} data-toggle="tooltip" title={events[0].event_name} data-original-title="Gallery" data-bs-original-title="" data-rel="ntd">
                            <img src={global.variables.strApiUrl + "/events-main-image/" + events[0].event_thumbnail} className="img-fluid rounded-2 p-1 bg-white" alt={events[0].event_name} title={events[0].event_name} />
                          </Link>
                        </figure>
                      :
                      <figure className="overflow-hidden rounded-2 m-0">
                        <img src={global.variables.strApiUrl + "/events-main-image/" + events[0].event_thumbnail} className="img-fluid rounded-2 p-1 bg-white" alt={events[0].event_name} title={events[0].event_name} />
                      </figure>
                    :
                    <figure className="overflow-hidden rounded-2 m-0">
                      <img src={global.variables.strDomainUrl + "images/default-thumb.jpg"} className="img-fluid rounded-2 p-1 bg-white" />
                    </figure>
                  }
                  <ul className="news-gal d-flex flex-column mb-3">
                    <li className="btnlist d-flex mb-2 wow fadeInUp">
                      {
                        parseInt(events[0].event_gallery_count) > 0 ?
                        <Link onClick={event => InvokePhotoGallery(event, events[0].event_id)} data-toggle="tooltip" className="fancybox-media btn btn-slide rounded-pill text-start py-1 px-3" title={events[0].event_name} data-original-title="Gallery" data-bs-original-title="" data-rel="ntd">
                        <FaRegImage className="icon-20 me-2" />Photo Gallery
                        </Link>
                        :
                        null
                      }
                      {
                        events[0].event_url != null && events[0].event_url != '' ?
                          <Link to={events[0].event_url} target="_blank" class="btn btn-slide rounded-pill text-start mx-1 py-1 px-3">
                          <FaLink />
                          </Link>
                        :
                        null
                      }
                    </li>
                    <li className="btnlist d-flex mb-2 wow fadeInUp">
                      <Link to="/events" className="btn btn-slide rounded-pill text-start py-1">
                        <FaStepBackward className="me-2" />Back
                      </Link>
                    </li>

                  </ul>
                  {
                    eventPresentationList.length > 0 ?
                      <div className="bg-white p-3 rounded-2">
                        {
                          eventPresentationList.length === 1 ?
                          <>
                            <h5>Presentation</h5>
                            <ul style={{ listStyleType: "none", margin: "0px", paddingLeft: "0px" }}>
                              {
                                eventPresentationList.map((val)=>{
                                  return(

                                    <li className="py-2">
                                      <Link to={global.variables.strApiUrl + "/events-presentation/" + val.evtdoc_pdf}
                                      target="_blank">{val.evtdoc_title}</Link></li>
                                  )

                                })
                              }
                            </ul>
                          
                          </>
                          :
                          <>
                            <h5>Presentations</h5>
                            <ol>
                              {
                                eventPresentationList.map((val)=>{
                                  return(

                                    <li className="py-2">
                                      <Link to={global.variables.strApiUrl + "/events-presentation/" + val.evtdoc_pdf}
                                      target="_blank">{val.evtdoc_title}</Link></li>
                                  )

                                })
                              }
                            </ol>
                          
                          </>
                        }
                      </div>
                    :
                      null
                  }
                </Col>
                <div className="eve-info col-xxl-9 col-xl-8 py-2 ps-lg-4 ps-3">
                  <h5 className="text-dark mb-1"><b>{events[0].event_name}</b></h5>
                  {
                    //check for the equal date 
                    events[0].event_from_date === events[0].event_to_date ?
                      events[0].event_time != "" && events[0].event_time != null ?
                        <p className="wow"><b>Date and Time:</b> {events[0].event_from_date}, {events[0].event_time}</p>
                        :
                        <p className="wow"><b>Date:</b> {events[0].event_from_date}</p>
                      :
                        events[0].event_time != "" && events[0].event_time != null ?
                        <p className="wow"><b>Date and Time:</b> {`${events[0].event_from_date} to ${events[0].event_to_date}`}, {events[0].event_time}</p>
                        :
                        <p className="wow"><b>Date:</b> {`${events[0].event_from_date} to ${events[0].event_to_date}`}</p>
                  }
                    {
                      events[0].event_details != "" && events[0].event_details != null ?
                      <div className="wow ck-content" dangerouslySetInnerHTML={{ __html : events[0].event_details}}>
                      </div>
                      :
                      null
                    }
                  <ul className="news-gal">
                    <li className="btnlist wow fadeInUp">
                      <Link to="/events" className="btn btn-slide rounded-pill py-1 px-3"
                        data-toggle="tooltip" title="" data-original-title="Event"
                        data-bs-original-title="">
                        Back
                      </Link>
                    </li>
                  </ul>
                </div>
              </Row>
            </Container>
          :
            <Container className="px-0 bg-panels">
              <Row className="box p-xl-4 p-2 rounded-3">
                <span className="text-center">Loading...</span>
              </Row>
            </Container>
        }
      </Container>

      {/* events Gallery popup */}
            {/* this link will open the news gallery popup which will be hidden because the button from the grid is causing issue */}
            <a onClick={(e) => {
                e.preventDefault();
                setEventsGalleryToggler(!events_gallery_toggler);
            }}
                className="d-none"
                id="lnk_trigger_events_gallery_popup"></a>

        <FsLightbox toggler={events_gallery_toggler}
              sources={events_gallery?.map(item => {
              return(
                <div style={{
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'center', 
                  justifyContent: 'center'
                }} key={item.egallery_id} className="fsDiv">
                <img className="img-fluid" src={`${globalVariables.variables.strApiUrl}/events-gallery-image/${item.egallery_pic}`} alt={item.egallery_title} style={{ objectFit: 'contain' }} />
                <p style={{ textAlign: 'center', color: 'white', fontSize: '16px' }}>{item.egallery_title}</p>
                </div>
              )
            })}
            key={gallery_key}
          />

             {/* Video popup */}
            {/* this link will open the video popup which will be hidden because the button from the grid is causing issue */}
            <a onClick={(e) => {
                e.preventDefault();
                setvideosToggler(!videos);
            }}
                className="d-none"
                id="lnk_trigger_video_popup_event"></a>

            <FsLightbox
                toggler={videos}
                sources={lightbox_video}
            />

      {/* Breadcrumb */}
      <Container fluid className="small pt-3 p-0 bg-white d-flex justify-content-center mt-auto" >
        <Breadcrumb>
          <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
          <Breadcrumb.Item href={global.variables.strDomainUrl + "events"}>Events/Workshops</Breadcrumb.Item>
          <Breadcrumb.Item active>Events Detail</Breadcrumb.Item>
        </Breadcrumb>
      </Container>
      {/* Breadcrumb */}
    </>
  );
}